/**
 * @description 重要操作记录 customExpiration
 * @author xiehan
 * @date 2020/02/20
 */

import Logic from '../logic-base'
import ExportTable from '@/utils/exportTable'

const customExpirationBiz = new Logic()

customExpirationBiz.delete = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.customExpiration.delete,
    data: data
  })
}

customExpirationBiz.deleteBatch = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.customExpiration.deleteBatch,
    data: data
  })
}

customExpirationBiz.query = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.customExpiration.query,
    data: data
  })
}

customExpirationBiz.save = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.customExpiration.save,
    data: data
  })
}

customExpirationBiz.update = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.customExpiration.update,
    data: data
  })
}

/**
 * Created by xiehan on 2020/02/20.
 * 自定义到期提醒
 * @param fields 表头信息{name: text,...}
 * @param time  时间需要转换的表头
 * @param staticDictionary 静态字典
 */
customExpirationBiz.export = function (fields, search, time, staticDictionary, success, fail) {
  const exportTable = new ExportTable({
    requestData: this.REQUEST_OPT.customExpiration.query,
    fields: fields,
    search: search,
    time: time,
    staticDictionary: staticDictionary,
    isJson: 0
  })
  exportTable.send(success, fail)
}

export default customExpirationBiz
